import React from "react";
import { Layout } from "antd";

const PageLayout = ({ title, dropdowns, content, subTitle }) => {
  return (
    <Layout
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: "0px 24px",
        paddingBottom: "42px",
        minHeight: "100%",
        width: "100%",
      }}
    >
      <div
        style={{
          margin: "1em",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div>
          <h1>{title}</h1>
          {subTitle ? (
            <h3
              style={{
                marginTop: "-1em",
                marginLeft: "0.2em",
              }}
            >
              {subTitle}
            </h3>
          ) : null}
        </div>
        <div style={{
          width: "100%"
          }}>
          {dropdowns}
        </div>
      </div>
      <Layout.Content
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          justifyItems: "center",
          width: "100%",
          minHeight: "100%",
          padding: "0px 16px",
        }}
      >
        {content}
      </Layout.Content>
    </Layout>
  );
};

export default PageLayout;
